export default __webpack_public_path__ + "maxcdn-website-logo.png";